<div class="h-full flex justify-center overflow-x-hidden border-app-chat-sources-border-color"
    [ngClass]="{'border-t-app-chat-sources-border-width': !!drawer?.opened}" *ngIf="setupCompleted">

    <!-- Chat page -->
    <mat-drawer-container class="h-full w-full flex flex-row">
        <!-- Chat related content -->
        <mat-drawer-content class="h-full grow items-center flex flex-col bg-white">

            <!-- Processing warning -->
            <div class="flex items-center justify-between w-full bg-[#fcefee] px-4 gap-4" *ngIf="showProcessingWarning">
                <p class="text-base grow py-4 text-center" i18n>
                    Deze collectie wordt momenteel verwerkt. Mogelijk worden niet alle documenten
                    meegenomen in de antwoorden van de chatbot.
                </p>
                <button mat-icon-button class="scale-75" (click)="showProcessingWarning = false">
                    <mat-icon svgIcon="x" class="scale-125"></mat-icon>
                </button>
            </div>

            <!-- Failed documents warning -->
            <div class="flex items-center justify-between w-full bg-[#fcefee] px-4 gap-4"
                *ngIf="showFailedDocumentsWarning">
                <p class="text-base grow py-4 text-center" i18n>
                    Deze collectie bevat documenten die niet goed zijn verwerkt. Deze documenten worden niet
                    meegenomen in de antwoorden van de chatbot.
                </p>
                <button mat-icon-button class="scale-75" (click)="showFailedDocumentsWarning = false">
                    <mat-icon svgIcon="x" class="scale-125"></mat-icon>
                </button>
            </div>

            <!-- Collection deleted warning -->
            <div *ngIf="selectedCollection && showCollectionDeletedWarning"
                class="flex items-center justify-between w-full bg-[#fcefee] px-4 gap-4">
                <p class="text-base grow py-4 text-center" i18n>
                    De collectie waarin deze chat plaatsvond is verwijderd op
                    {{ selectedCollection.deleted_at | date: 'dd/MM/yyyy' }}.
                    U kunt niet meer verder chatten.
                </p>
                <button mat-icon-button class="scale-75" (click)="showCollectionDeletedWarning = false">
                    <mat-icon svgIcon="x" class="scale-125"></mat-icon>
                </button>
            </div>

            <!-- Back button and context name on mobile -->
            <div class="w-full flex items-center gap-2 pl-4 pr-8 py-3" *ngIf="!breakpoint.lg.value">
                <button mat-icon-button aria-label="Terug" *ngIf="!breakpoint.lg.value" class="scale-[0.8]"
                    routerLink="/chat/new">
                    <mat-icon svgIcon="arrow-left" class="text-app-global-text-primary shrink-0 scale-[1.2]"></mat-icon>
                </button>
                <p *ngIf="selectedCollection"
                    class="text-[22px] px-[8px] py-[10px] bg-app-global-quaternary text-app-global-quaternary-contrast rounded-[5px] whitespace-nowrap text-ellipsis overflow-hidden h-10">
                    {{selectedCollection.name}}
                </p>
            </div>

            <!-- Collection and messages -->
            <div *ngIf="!canShowContentInCenter() "
                class="grow w-full overflow-auto flex flex-col items-center gutter messages-container gap-[30px] pt-[30px]"
                #messagesContainer>

                <!-- Selected collection -->
                <div *ngIf="selectedCollection" class="flex flex-col items-center gap-2 max-w-[814px] px-8"
                    [ngClass]="{'hidden': !breakpoint.lg.value}">
                    <p class="text-base" i18n>Geselecteerde collectie</p>
                    <div
                        class="flex flex-row items-center rounded-full bg-app-chat-selected-collection-background px-4 h-[50px] gap-1 w-fit">
                        <p
                            class="text-base text-app-chat-selected-collection-text max-w-[300px] text-ellipsis line-clamp-1 overflow-hidden">
                            {{selectedCollection.name}}
                        </p>
                        <button mat-icon-button aria-label="Collectie aanpassen" routerLink="/chat/new"
                            class="scale-[0.8] mr-[-16px]"
                            *ngIf="!messages.length && !chatFeedService.selectedChatId$.value">
                            <mat-icon svgIcon="pencil" class="text-app-global-quaternary-contrast"></mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Messages -->
                <div class="flex flex-col gap-[30px] max-w-[814px] px-8 w-full">
                    <div *ngFor="let message of messages; let last = last" class="w-full"
                        [ngClass]="{'mb-[-20px]': message.type === 'response'}">
                        <!-- User prompt -->
                        <div *ngIf="message.type === 'prompt'" class="flex flex-col grow gap-1 items-end ">
                            <!-- Attachments -->
                            <div *ngFor="let attachment of message.attachments"
                                (click)="openAttachmentDialog(attachment.id)"
                                class="flex items-center h-[36px] w-[220px] gap-1 p-[10px] border border-app-chat-input-document-border rounded-xl cursor-pointer">
                                <mat-icon svgIcon="file" class="scale-[0.8] shrink-0 w-5"></mat-icon>
                                <p class="truncate grow" [matTooltip]="attachment.fileName">{{ attachment.fileName }}
                                </p>
                            </div>

                            <!-- Prompt -->
                            <markdown [data]="message.content"
                                class="text-base p-4 pb-0 bg-app-chat-prompt-background rounded-[25px] max-w-[80%] ml-auto whitespace-pre-line break-words">
                            </markdown>
                        </div>
                        <!-- Response -->
                        <div *ngIf="message.type === 'response'"
                            [style.min-height.px]="last ? defaultResponseHeight : 0">
                            <!-- Awaiting response -->
                            <div>
                                <p [shimmer]="true" [pulse]="true"
                                    *ngIf="!message.reasoningContent && !message.content && !message.hideWaitAnimation"
                                    class="text-base text-app-global-text-secondary h-6 mt-[3px] w-fit">⬤</p>
                            </div>
                            <!-- Reasoning -->
                            <expansion-content *ngIf="message.reasoningContent" class="block mb-3">
                                <p title [shimmer]="!!message.isReasoning">
                                    <span i18n *ngIf="message.isReasoning">Aan het nadenken...</span>
                                    <ng-content *ngIf="!message.isReasoning && message.reasoningDuration">
                                        <span i18n>Nagedacht voor </span>
                                        <span i18n>{{message.reasoningDuration}}</span>
                                        <span i18n *ngIf=" message.reasoningDuration === 1">
                                            seconde
                                        </span>
                                        <span i18n *ngIf="message.reasoningDuration !== 1">
                                            seconden
                                        </span>
                                    </ng-content>
                                    <ng-content *ngIf="!message.isReasoning && !message.reasoningDuration">
                                        <span i18n>Denkproces</span>
                                    </ng-content>
                                </p>
                                <div class="pl-4 py-2 border-l border-app-chat-sources-border-color">
                                    <markdown katex [data]="message.reasoningContent"
                                        class="text-base whitespace-pre-line break-words block mb-[-20px]">
                                    </markdown>
                                </div>
                            </expansion-content>

                            <!-- Content with clipboard in code blocks -->
                            <markdown katex [clipboard]="!blockSend" [data]="message.content"
                                class="text-base whitespace-pre-line break-words">
                            </markdown>

                            <!-- Sources  -->
                            <button mat-stroked-button class="mb-[25px] h-[32px]" *ngIf="message.sources?.length"
                                (click)="setSources(message.sources, drawer)">
                                <mat-icon svgIcon="book"></mat-icon>
                                <ng-container i18n>Bronnen</ng-container>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Prompt input -->
            <div *ngIf="!selectedCollection?.deleted_at"
                class="max-w-[814px] flex flex-col justify-between items-center gap-10 px-8 py-0 w-full"
                [ngClass]="{'mt-[25vh]': canShowContentInCenter() }">
                <h1 *ngIf="canShowContentInCenter()" class="text-[34px] text-center" i18n>
                    Chatten <span class="font-semibold"> zonder collectie</span>
                </h1>
                <div
                    class="shrink-0 w-full rounded-[35px] bg-app-chat-input-background shadow-[inset_0_0_0_1px] shadow-app-chat-input-border min-h-[120px] flex flex-col">
                    <!-- Uploaded files in-chat -->
                    <div *ngIf="fileSelector?.files!.length > 0"
                        class="w-full flex flex-wrap gap-1 px-5 pt-5 mb-[-5px]">
                        <a *ngFor="let file of fileSelector?.files" (click)="openAttachmentDialog(file?.attachment_id)"
                            class="flex items-center h-[36px] w-[230px] gap-1 p-[10px] border border-app-chat-input-document-border rounded-lg"
                            [ngClass]="file.attachment_id && 'cursor-pointer'">
                            <mat-icon *ngIf="file.status === 'available'" svgIcon="file"
                                class="scale-[0.8] shrink-0 w-5"></mat-icon>
                            <mat-spinner *ngIf="file.status === 'processing'" class="shrink-0 w-5"
                                [diameter]="18"></mat-spinner>
                            <mat-icon *ngIf="file.status === 'failed'" svgIcon="file-warning"
                                class="scale-[0.8] shrink-0 w-5 text-app-global-warning"></mat-icon>
                            <p class="truncate grow" [matTooltip]="file.file.name">{{ file.file.name }}</p>
                            <button mat-icon-button
                                class="scale-[0.8] shrink-0 !w-5 !h-5 flex items-center justify-center" disableRipple
                                (click)="removeFile(file); $event.stopPropagation();">
                                <mat-icon svgIcon="x" class="shrink-0"></mat-icon>
                            </button>
                        </a>
                    </div>
                    <!-- Prompt input text area -->
                    <mat-form-field class="w-full px-5 pt-5 pb-[5px] chat-input">
                        <textarea matInput id="chatInputArea" i18n-placeholder [placeholder]="chatInputPlaceholder"
                            [formControl]="chatControl" (keydown.enter)="sendMessage($event)" cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
                    </mat-form-field>
                    <div class="flex w-full h-full justify-between items-center p-4">
                        <div class="flex items-center h-6">
                            <!-- Plus button -->
                            <button *ngIf="!this.selectedCollection" mat-icon-button #trigger="matMenuTrigger"
                                [matMenuTriggerFor]="menu" color="secondary"
                                class="shrink-0 scale-[0.8] ml-[-8px] mb-[-2px]"
                                [ngClass]="{ 'bg-[#F0F1F1]': trigger.menuOpen}">
                                <mat-icon svgIcon="plus" iconPositionEnd></mat-icon>
                            </button>
                            <mat-menu #menu="matMenu" [xPosition]="'after'" class="menu-class">
                                <!-- Upload files in-chat -->
                                <button mat-menu-item (click)="uploadFiles()">
                                    <mat-icon svgIcon="paperclip"></mat-icon>
                                    <span i18n>Bestanden uploaden</span>
                                    <!-- Hidden file selector -->
                                    <file-selector class="hidden" [allowedFileExtensions]="['.pdf', '.docx', '.md']"
                                        [multiple]="true" #fileSelector [maxFiles]="5" defaultStatus="processing">
                                    </file-selector>
                                </button>
                            </mat-menu>

                            <!-- Toggle chunk retrieval -->
                            <div *ngIf="showChunkRetrievalButton" class="switch-button max-h-min"
                                [ngClass]="{'enabled': retrieveChunks}" (click)="toggleRetrieveChunks()">
                                <mat-checkbox class="barebonesCheckbox flex gap-1" [checked]="retrieveChunks"
                                    hideSingleSelectionIndicator>
                                    <div class="flex gap-1 items-center">
                                        <mat-icon svgIcon="file-search"
                                            class="ml-[-6px] w-6 h-6 text-app-global-primary">
                                        </mat-icon>
                                        <p class="text-base text-app-global-primary pr-2" i18n>
                                            Doorzoek documenten
                                        </p>
                                    </div>
                                </mat-checkbox>
                            </div>
                        </div>
                        <!-- Send prompt -->
                        <button aria-label="Verstuur vraag" (click)="sendMessage()" color="secondary"
                            class="send-chat-button flex items-center justify-center rounded-full h-[40px] w-[40px] p-1"
                            [disabled]="chatControl.invalid || blockSend">
                            <mat-icon svgIcon="arrow-up" class="text-app-button-primary-text"></mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <!-- AI disclaimer -->
            <p class="text-app-global-text-secondary py-2 px-8 text-xs text-center" i18n>
                AI-gegenereerde informatie kan fouten bevatten. Controleer belangrijke informatie.
            </p>
        </mat-drawer-content>

        <!-- Sources -->
        <mat-drawer
            class="sources py-[25px] pr-[25px] flex flex-col gap-[9px] border-l border-app-chat-sources-border-color bg-white"
            position="end" [mode]="!breakpoint.xl.value ? 'over' : 'side'" #drawer>
            <!-- Title and close button -->
            <div class="flex justify-between items-start pl-[25px]">
                <p class="text-base font-semibold" i18n>Bronnen</p>
                <button mat-icon-button aria-label="Bronnen sluiten" class="mr-[-12px] mt-[-12px]"
                    (click)="drawer.close()">
                    <mat-icon svgIcon="x" class="text-app-global-text-primary scale-[0.8]"></mat-icon>
                </button>
            </div>
            <!-- List of sources -->
            <div class="flex flex-col ml-[15px]">
                <div *ngFor="let source of activeSources"
                    class="flex flex-col hover:bg-gray-100 p-[10px] rounded-lg cursor-pointer"
                    (click)="showSource(chunkDialog)">
                    <!-- File name -->
                    <div class="flex gap-[5px] items-center mb-[5px]">
                        <mat-icon *ngIf="!source.document.deleted_at" svgIcon="file"
                            class="shrink-0 w-4 h-4"></mat-icon>
                        <mat-icon *ngIf="source.document.deleted_at" svgIcon="file-question-mark"
                            class="shrink-0 w-4 h-4 text-app-global-warning cursor-pointer"
                            [matTooltip]="'Dit document is verwijderd uit de collectie op ' + (source.document.deleted_at | date: 'dd/MM/yyy')"></mat-icon>
                        <p class="text-sm font-semibold break-word">{{source.document.name}}</p>
                    </div>
                    <!-- Source content -->
                    <p class="text-app-global-text-secondary break-words line-clamp-5">{{source.text}}</p>

                    <!-- Dialog that shows chunk content and buttons to open or download file -->
                    <dynamic-dialog #chunkDialog [maxWidth]="1000" [showActions]="false">
                        <ng-container *ngTemplateOutlet="dialogContent; context: { 
                            dialogRef: chunkDialog,
                            title: source.document.name,
                            subtitle: source.pages ? chunkDetailSubtitle + source.pages.join(', ') : null,
                            body: source.text,
                            fileId: !source.document.deleted_at ? source.document.file_id : undefined,
                            fileName: source.document.name,
                            chunkId: source.id
                        }"></ng-container>
                        <span cancel-button class="hidden"></span>
                        <span confirm-button class="hidden"></span>
                    </dynamic-dialog>
                </div>
            </div>
        </mat-drawer>
    </mat-drawer-container>
</div>

<!-- Dialog to show when the user clicks a message attachment -->
<dynamic-dialog #attachmentDialog [maxWidth]="1000" [showActions]="false">
    <ng-container *ngTemplateOutlet="dialogContent; 
        context: {
            dialogRef: attachmentDialog,
            title: attachmentDetail?.File?.name, 
            subtitle: attachmentDetailSubtitle,
            body: attachmentDetail?.full_text,
            fileId: attachmentDetail?.File?.id,
            fileName: attachmentDetail?.File?.name
        }">
    </ng-container>
    <!-- Hide cancel and confirm buttons -->
    <span cancel-button class="hidden"></span>
    <span confirm-button class="hidden"></span>
</dynamic-dialog>

<!-- Re-usable template to showcase a chunk or attachment details as dialog content -->
<ng-template #dialogContent let-title="title" let-subtitle="subtitle" let-body="body" let-type="type"
    let-fileId="fileId" let-fileName="fileName" let-chunkId="chunkId" let-dialogRef="dialogRef">
    <div class="flex flex-col gap-[15px] min-h-[40vh]">
        <div class="flex flex-row justify-between items-center w-full">
            <!-- Title & subtitle -->
            <div class="flex flex-col items-start gap-1 min-w-0 flex-1">
                <h1 title class="font-semibold truncate min-w-0 max-w-full">
                    {{ title }}
                </h1>
                <h2 *ngIf="subtitle" class="text-base text-app-global-text-secondary" i18n>
                    {{ subtitle }}
                </h2>
            </div>
            <!-- Close button -->
            <button mat-icon-button (click)="dialogRef.close()" class="flex items-center "
                [ngClass]="subtitle ? 'mt-[-20px] mr-[-20px]' : ''">
                <mat-icon svgIcon="x" class="text-app-global-text-primary"></mat-icon>
            </button>
        </div>
        <p
            class="scrollable-dialog whitespace-pre-wrap flex-grow lg:max-h-[50vh] max-h-[40vh] overflow-y-auto text-base pr-2">
            {{ body }}
        </p>
    </div>

    <!-- Open file or download button -->
    <div class="flex ml-auto">
        <button *ngIf="fileId && fileName | canViewFileInBrowser" confirm-button mat-flat-button color="secondary"
            class="mb-[-20px] mr-[-20px] px-[15px] flex scale-90 min-w-fit" (click)="viewSourceFile(fileId, chunkId)">
            <mat-icon icon svgIcon="external-link" class="mx-0"></mat-icon>
            <p class="text-app-button-secondary-text ml-2" i18n>Document openen</p>
        </button>
        <button *ngIf="fileId && !(fileName | canViewFileInBrowser)" mat-flat-button color="secondary"
            class="mb-[-20px] mr-[-20px] px-[15px] flex scale-90 min-w-fit"
            (click)="downloadSourceFile(fileId, fileName)">
            <mat-icon icon svgIcon="download" class="mx-0"></mat-icon>
            <p class="text-app-button-secondary-text ml-2" i18n>Document downloaden</p>
        </button>
    </div>
</ng-template>